import { lazy } from "react";
import Loadable from "../layouts/loader/Loadable";
import AuthGuard from "../utils/AuthGuard";
import LoginGuard from "../utils/LoginGuard";
import Role from "../utils/Roles";
import Customers from "../views/apps/customerManagement/Index.js";
import DemoSetup from "src/views/demo";

import ContractDetails from "src/views/contract/ContractDetails";
import ContractLayout from "src/layouts/contractLayout";

import ContractLogin from "src/views/contract/auth/Login";
import ContractLoginGuard from "src/utils/ContractLoginGuard";
import ContractAuthGuard from "src/utils/ContractAuthGuard";


const Subscriptions = Loadable(lazy(() => import("../views/subscriptions")));
const ConnectMediumPage = Loadable(
  lazy(() => import("../views/connectChat/ConnectMediumPage.jsx"))
);
const SubscriptionsList = Loadable(lazy(() => import("../views/apps/subscriptions/Index.js")));
const PaymentConfirmation = Loadable(lazy(() => import("../views/subscriptions/PaymentConfirmation.jsx")));
/****Layouts*****/

const FullLayout = Loadable(lazy(() => import("../layouts/FullLayout")));
const BlankLayout = Loadable(lazy(() => import("../layouts/BlankLayout")));
const PublicLayout = Loadable(lazy(() => import("../layouts/PolicyLayout")));
/***** Pages ****/

const General = Loadable(lazy(() => import("../views/dashboards/General")));

/***** Apps ****/
const AccountSetup = Loadable(lazy(() => import("../views/auth/AccountSetup")));
const LoginHistory = Loadable(lazy(() => import("../views/apps/loginHistory")));

const Email = Loadable(lazy(() => import("../views/apps/email/Email")));

const Taskbaord = Loadable(lazy(() => import("../views/apps/taskboard/Taskboard")));
const TaskBoardNew = Loadable(lazy(() => import("../views/apps/taskBordNew/index")));

const Todo = Loadable(lazy(() => import("../views/apps/todo/Todo")));
const Pricing = Loadable(lazy(() => import("../views/apps/pricing")));
const Contacts = Loadable(lazy(() => import("../views/apps/contacts")));
const Calendar = Loadable(
  lazy(() => import("../views/apps/calendar/CalendarApp"))
);
const NewCalendarApp = Loadable(lazy(() => import("../views/apps/newCalendar")));

const TicketList = Loadable(
  lazy(() => import("../views/apps/ticket/TicketList"))
);
const TicketDetail = Loadable(
  lazy(() => import("../views/apps/ticket/TicketDetail"))
);

const Profile = Loadable(lazy(() => import("../views/sample-pages/Profile")));
const LeadCalendar = Loadable(lazy(() => import("../views/leadCalendar")));

const Transactions = Loadable(
  lazy(() => import("../views/apps/transactions/Index"))
);
const ManageChat = Loadable(
  lazy(() => import("../views/apps/manageChat/Index"))
);

const Users = Loadable(lazy(() => import("../views/apps/users/Index")));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import("../views/auth/Error")));

const LoginFormik = Loadable(lazy(() => import("../views/auth/LoginFormik")));
const Maintanance = Loadable(lazy(() => import("../views/auth/Maintanance")));
const RecoverPassword = Loadable(
  lazy(() => import("../views/auth/RecoverPassword"))
);
const RecoverPwd = Loadable(lazy(() => import("../views/auth/RecoverPwd")));
const TermsAndCondition = Loadable(
  lazy(() => import("../views/policy/TermsAndConditions.jsx"))
);
const PrivacyPolicy = Loadable(
  lazy(() => import("../views/policy/PrivacyPolicy.jsx"))
);
const UnsubscribeEmail = Loadable(lazy(() => import("../views/unsubscribe")));
const UnsubscribeEmailThanksPage = Loadable(lazy(() => import("../views/unsubscribe/Thanks")));
const LiveChat = Loadable(lazy(() => import("../views/apps/liveChat")));
const Channels = Loadable(lazy(() => import("../views/sample-pages/channels")));

const ChatBotBuilder = Loadable(lazy(() => import("../views/chatbotBuilder")));

const CalendarAuth = Loadable(lazy(() => import("../views/calendar")));

const Contract = Loadable(lazy(() => import("../views/contract")))
const CreateContract = Loadable(lazy(() => import("../views/contract/createContract")));
const ContractVerification = Loadable(lazy(() => import("../views/contract/verifyContract")))
const Success = Loadable(lazy(() => import("../views/contract/success")))
const PaymentFail = Loadable(lazy(() => import("../views/contract/success")))

/*****Routes******/
const ThemeRoutes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        name: "general",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <General />
          </Role>
        ),
      },
      {
        path: "dashboard",
        name: "general",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <General />
          </Role>
        ),
      },
      {
        path: "taskboard",
        name: "taskbaord",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Taskbaord />
          </Role>
        ),
      },
      {
        path: "taskboard-new",
        name: "taskbaordnew",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <TaskBoardNew />
          </Role>
        ),
      },
      {
        path: "taskboardnew",
        name: "taskbaordnewone",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <TaskBoardNew />
          </Role>
        ),
      },
      {
        path: "todo",
        name: "taskbaord",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Todo />
          </Role>
        ),
      },

      {
        path: "livechat",
        name: "Live chat",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <LiveChat />
          </Role>
        ),
      },

      {
        path: "contacts",
        name: "contacts",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Contacts />
          </Role>
        ),
      },
      {
        path: "calendar2",
        name: "calendar2",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Calendar />
          </Role>
        ),
      },
      {
        path: "calendar",
        name: "calendar",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <NewCalendarApp />
          </Role>
        ),
      },
      {
        path: "login-history",
        name: "login history",
        exact: true,
        element: (
          <Role
            roles={["superadmin"]}>
            <LoginHistory />
          </Role>
        ),
      },
      {
        path: "email",
        name: "email",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Email />
          </Role>
        ),
      },
      {
        path: "users",
        name: "users",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Users />
          </Role>
        ),
      },
      {
        path: "transactions",
        name: "transactions",
        exact: true,
        element: (
          <Role roles={["superadmin", "companyadmin"]}>
            <Transactions />
          </Role>
        ),
      },
      {
        path: "conversations",
        name: "conversations",
        exact: true,
        element: (
          <Role roles={["superadmin", "companyadmin"]}>
            <ManageChat />
          </Role>
        ),
      },
      {
        path: "subscription-list",
        name: "subscriptions",
        exact: true,
        element: (
          <Role roles={["superadmin", "companyadmin"]}>
            <SubscriptionsList />
          </Role>
        ),
      },
      {
        path: "pricing",
        name: "pricing",
        exact: true,
        element: (
          <Role roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Pricing />
          </Role>
        ),
      },
      {
        path: "leads",
        name: "leads",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <TicketList />
          </Role>
        ),
      },
      {
        path: "leads/detail",
        name: "lead detail",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <TicketDetail />
          </Role>
        ),
      },
      {
        path: "/channels",
        name: "channels",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin"]}>
            <Channels />
          </Role>
        ),
      },
      {
        path: "sample-pages/profile",
        name: "profile",
        exact: true,
        element: (
          <Role
            roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <Profile />
          </Role>
        ),
      },
      {
        path: "customer-management",
        name: "Customer Management",
        exact: true,
        element: (
          <Role roles={["superadmin"]}>
            <Customers />
          </Role>
        ),
      },
      {
        path: "chatbot-builder",
        name: "Chatbot Builder",
        exact: true,
        element: (
          <Role roles={["superadmin", "companyadmin"]}>
            <ChatBotBuilder />
          </Role>
        ),
      },
      {
        path: "calendar-connect",
        name: "Calendar Connect",
        exact: true,
        element: (
          <Role roles={["superadmin", "companyadmin"]}>
            <CalendarAuth />
          </Role>
        ),
      },
      {
        path: "setup-demo",
        name: "Setup Demo",
        exact: true,
        element: (
          <Role roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
            <DemoSetup />
          </Role>
        ),
      },
    ],
  },
  {
    path: "auth",
    element: (
      <LoginGuard>
        <BlankLayout />
      </LoginGuard>
    ),
    children: [
      { path: "404", element: <Error /> },


      { path: "login", element: <LoginFormik /> },
      { path: "maintanance", element: <Maintanance /> },

      { path: "recoverpwd", element: <RecoverPassword /> },
      { path: "forgotPwd", element: <RecoverPwd /> },
    ],
  },


  {
    path: "eSignature",
    element: (<BlankLayout />),
    children: [
      {
        path: "login",
        element: (<ContractLoginGuard> <ContractLogin /> </ContractLoginGuard>),
      },
      {
        path: "dashboard", element: <ContractAuthGuard> <ContractLayout /> </ContractAuthGuard>,
        children: [{
          path: "contract",
          name: "contract",
          exact: true,
          element: (
            <Contract />
          )
        },
        {
          path: "/eSignature/dashboard/create-contract",
          name: "create-contract",
          exact: true,
          element: (
            <CreateContract />
          )
        },
        {
          path: "/eSignature/dashboard/contract-details/:id",
          name: "Contract details",
          exact: true,
          element: (
            <ContractDetails />
          )
        },]
      },

    ],
  },

  { path: "unsubscribe", element: <UnsubscribeEmail /> }, // for email template
  { path: "unsubscrib-thanks", element: <UnsubscribeEmailThanksPage /> },
  { path: "subscriptions/:plan", element: <Subscriptions /> },
  { path: "return", element: <PaymentConfirmation /> },
  { path: "contract-verification", element: <ContractVerification /> },
  { path: "success", element: <Success /> },
  { path: "failed", element: <PaymentFail /> },
  {
    path: "account-setup",
    name: "account setup",
    exact: true,
    element: (
      <AuthGuard>
        <Role roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
          <AccountSetup />
        </Role>
      </AuthGuard>
    ),
  },
  {
    path: "connect-channels",
    name: "connect channels",
    exact: true,
    element: (
      <AuthGuard>
        <Role roles={["superadmin", "companyadmin", "companymanager", "agent"]}>
          <ConnectMediumPage />
        </Role>
      </AuthGuard>
    ),
  },
  { path: "lead-calendar", element: <LeadCalendar /> },
  {
    path: "policy",
    element: <PublicLayout />,
    children: [
      { path: "terms-of-service", element: <TermsAndCondition /> },
      { path: "privacypolicy", element: <PrivacyPolicy /> },
    ],
  },
  { path: "*", element: <Error /> },
];

export default ThemeRoutes;
